export function StatusPill({
  status,
  label,
  icon,
}: {
  status: "ok" | "warn" | "danger" | "info" | "neutral";
  label: string;
  icon?: string;
}) {
  return (
    <span className={`rep-status-pill ${status}`}>
      <span className="rep-status-dot" aria-hidden="true" />
      {icon && <span className="rep-status-icon" aria-hidden="true">{icon}</span>}
      <span>{label}</span>
    </span>
  );
}

export function ReviewStatusBadge({
  publicStatus,
  workflowStatus,
  riskLevel,
}: {
  publicStatus: "sin_responder" | "respondida" | "publicada";
  workflowStatus?: string;
  riskLevel?: "bajo" | "medio" | "alto";
}) {
  if (riskLevel === "alto" || workflowStatus === "delicada") {
    return <StatusPill status="danger" label="Para revisar" />;
  }
  if (publicStatus === "publicada" || publicStatus === "respondida") {
    return <StatusPill status="ok" icon="✓" label="Respondida" />;
  }
  if (workflowStatus === "sugerida") {
    return <StatusPill status="info" icon="✨" label="Respuesta sugerida" />;
  }
  return <StatusPill status="warn" icon="○" label="Sin responder" />;
}

export function ResponseStatusBadge({ status }: { status: string }) {
  switch (status) {
    case "publicada":
      return <StatusPill status="ok" icon="✓" label="Publicada en Google" />;
    case "aprobada":
      return <StatusPill status="info" icon="✓" label="Aprobada" />;
    case "sugerida":
      return <StatusPill status="info" icon="✨" label="Borrador generado por IA" />;
    case "rechazada":
      return <StatusPill status="warn" icon="↺" label="Sugerencia descartada" />;
    case "error_publicacion":
      return <StatusPill status="danger" icon="✕" label="Error al publicar" />;
    default:
      return <StatusPill status="neutral" label={status} />;
  }
}

export function SentimentBadge({ sentiment }: { sentiment?: "positivo" | "neutral" | "negativo" | string }) {
  if (!sentiment) return null;
  switch (sentiment) {
    case "positivo":
      return <span className="rep-sentiment-badge positive">Positivo</span>;
    case "negativo":
      return <span className="rep-sentiment-badge negative">Negativo</span>;
    case "neutral":
    default:
      return <span className="rep-sentiment-badge neutral">Neutro</span>;
  }
}
